import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
const AdminRoute = ({ children }) => {
  const roles = useSelector((state) => state.auth.roles);
  return roles.includes("Admin") ? <>{children}</> : <Navigate to="/" />;
};
export default AdminRoute;
